export default __webpack_public_path__ + "static/media/marker-h.74852ad2.svg";